import React, { useState, useEffect } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  IconButton,
  InputLabel,
} from "@mui/material";

import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";

import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { InputValidatePropType } from "../../interface/input";
import { labelSty, styInput } from "./styles-input";

// export const useStyles = makeStyles((theme) => ({
//   customInput: {
//     "& .MuiFormControl-root": {
//       backgroundColor: "#f5f7f9", // Replace with your desired color
//     },
//     "& .MuiOutlinedInput-root": {
//       backgroundColor: "#f5f7f9",
//       borderRadius: "8px", // Adjust this value as needed
//       "& fieldset": {
//         border: "none",
//       },
//     },
//     "& .MuiInputBase-input": {
//       fontFamily: '"Lexend", sans-serif', // Replace with your desired font
//     },
//     "& .MuiSelect-select": {
//       backgroundColor: "#f5f7f9",
//       color: "#000",
//       fontSizr: "12px",
//       borderRadius: "8px", // Adjust this value as needed
//     },
//     iconButton: {
//       padding: "8px", // Adjust padding as needed
//     },
//     icon: {
//       fontSize: "20px", // Adjust size as needed
//       color: "#757575", // Adjust color as needed
//     },
//   },
// }));

// Styled components
export const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#f5f7f9",
    borderRadius: "8px", // Adjust this value as needed
    "& fieldset": {
      border: "none",
    },
    "& input": {
      // Add your styInput styles here
      backgroundColor: "#f5f7f9",
      borderRadius: "8px",
    },
  },
  "& .MuiFormHelperText-root": {
    // Style for error message
    color: theme.palette.error.main,
  },
  "& .MuiFormControl-root": {
    borderRadius: "8px",
    backgroundColor: "#f5f7f9", // Replace with your desired color
  },
}));
export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  // Add any custom styles for the IconButton here
  backgroundColor: "#f5f7f9",
  padding: theme.spacing(1),
}));

const EmailInput = ({
  errors,
  register,
  placeholder,
  labelText,
}: InputValidatePropType) => {
  // const classes = useStyles(); // Call the hook here

  return (
    <Stack
      sx={{
        marginBottom: 3,
      }}
    >
      <InputLabel sx={labelSty}>{labelText}</InputLabel>
      {/* <TextField
        // className={classes.customInput}
        placeholder={placeholder ?? "Enter your email address or phone number"}
        type="email"
        error={!!errors.email}
        helperText={errors.email ? errors.email.message : ""} // Render error message only when there's an error
        {...register("email")}
        InputProps={{
          inputProps: {
            style: styInput,
          },
        }}
      ></TextField> */}
      <StyledTextField
        placeholder={placeholder ?? "Enter your email address or phone number"}
        type="email"
        error={!!errors.email}
        helperText={errors.email ? errors.email.message : ""}
        {...register("email")}
      />
    </Stack>
  );
};
const NameInput = ({
  errors,
  register,
  placeholder,
  labelText,
}: InputValidatePropType) => {
  // const classes = useStyles();

  return (
    <Stack
      sx={{
        marginBottom: 3,
      }}
    >
      <InputLabel sx={labelSty}>{labelText}</InputLabel>
      <TextField
        placeholder={placeholder ?? "Enter Name"}
        type="text"
        error={!!errors.name}
        helperText={errors.name ? errors.name.message : ""} // Render error message only when there's an error
        {...register("name")}
        InputProps={{
          inputProps: {
            style: styInput,
          },
        }}
      ></TextField>
    </Stack>
  );
};
const PasswordInput = ({
  errors,
  register,
  placeholder,
  labelText,
}: InputValidatePropType) => {
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  // const classes = useStyles();

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Stack
      sx={{
        marginBottom: 3,
      }}
    >
      <InputLabel sx={labelSty}>{labelText}</InputLabel>
      {/* <TextField
        // className={classes.customInput}
        error={!!errors.password}
        helperText={errors.password ? errors.password.message : ""} // Render error message only when there's an error
        {...register("password")}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleTogglePassword}>
                {showPassword ? (
                  <VisibilityOutlinedIcon />
                ) : (
                  <VisibilityOffOutlinedIcon />
                )}
              </IconButton>
            </InputAdornment>
          ),
          inputProps: {
            style: styInput,
          },
        }}
      /> */}
      <StyledTextField
        error={!!errors.password}
        helperText={errors.password ? errors.password.message : ""}
        {...register("password")}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <StyledIconButton onClick={handleTogglePassword} edge="end">
                {showPassword ? (
                  <VisibilityOutlinedIcon />
                ) : (
                  <VisibilityOffOutlinedIcon />
                )}
              </StyledIconButton>
            </InputAdornment>
          ),
        }}
      />
    </Stack>
  );
};
const ConfirmPasswordInput = ({
  errors,
  register,
  placeholder,
  labelText,
}: InputValidatePropType) => {
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  // const classes = useStyles();

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Stack
      sx={{
        marginBottom: 3,
      }}
    >
      <InputLabel sx={labelSty}>{labelText}</InputLabel>
      <TextField
        // className={classes.customInput}
        error={!!errors.passwordConfirm}
        helperText={
          errors.passwordConfirm ? errors.passwordConfirm.message : ""
        } // Render error message only when there's an error
        {...register("passwordConfirm")}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleTogglePassword}>
                {showPassword ? (
                  <VisibilityOutlinedIcon />
                ) : (
                  <VisibilityOffOutlinedIcon />
                )}
              </IconButton>
            </InputAdornment>
          ),
          inputProps: {
            style: styInput,
          },
        }}
      />
    </Stack>
  );
};

const OTPInput = ({
  placeholder,
  register,
  errors,
  labelText,
}: InputValidatePropType) => {
  const theme = useTheme();
  // const classes = useStyles();
  const [inputValue, setInputValue] = useState("");

  const formatInput = (value: string) => {
    // Remove all non-digit characters
    const digitsOnly = value.replace(/\D/g, "");
    // Add dashes after every digit, but limit to 4 digits
    return digitsOnly.split("").slice(0, 4).join("-");
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatInput(event.target.value);
    setInputValue(formatted);
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData("text");
    const formatted = formatInput(pastedText);
    setInputValue(formatted);
  };

  useEffect(() => {
    register("code").onChange({
      target: { value: inputValue.replace(/-/g, "") },
    });
  }, [inputValue, register]);

  return (
    <Stack sx={{ marginBottom: 3 }}>
      <InputLabel sx={labelSty}>{labelText}</InputLabel>
      <TextField
        error={!!errors.code}
        // className={classes.customInput}
        helperText={errors.code ? errors.code.message : ""}
        {...register("code", {
          onChange: (e) => {
            handleInputChange(e);
          },
        })}
        value={inputValue}
        onPaste={handlePaste}
        placeholder={placeholder}
        InputProps={{
          inputProps: {
            style: styInput,
            maxLength: 7, // 4 digits + 3 dashes
          },
        }}
      />
    </Stack>
  );
};

export { PasswordInput, ConfirmPasswordInput, EmailInput, OTPInput, NameInput };
